import { createRowId } from '../ids';

import { createHeroCarouselItemDraftLabel, createOfferDraftLabel } from './offers';
import type {
  OffersHubHeroCarouselItem,
  OffersHubOffer,
  OffersHubOfferTag,
  OffersHubPayloadBuilderState,
} from './types';

export function createDefaultHeroCarouselItem(
  draftLabel = createHeroCarouselItemDraftLabel(0),
): OffersHubHeroCarouselItem {
  return {
    draftId: createRowId(),
    draftLabel,
    isActive: true,
    enabledRegions: [],
    startAt: '',
    endAt: '',
    label: '',
    imageId: '',
    logoImageId: '',
    title: '',
    description: '',
    ctaLabel: '',
    ctaUrl: '',
  };
}

export function createDefaultOffer(
  offerTag: OffersHubOfferTag = 'partner_offer',
  draftLabel = createOfferDraftLabel(0),
): OffersHubOffer {
  return {
    draftId: createRowId(),
    draftLabel,
    isActive: true,
    enabledRegions: [],
    startAt: '',
    endAt: '',
    offerTag,
    brandName: '',
    industry: '',
    imageId: '',
    title: '',
    description: '',
    ctaLabel: '',
    ctaUrl: '',
    urgencyType: 'none',
  };
}

export function createDefaultOffersHubState(): OffersHubPayloadBuilderState {
  return {
    mode: 'offersHub',
    heroCarouselItems: [],
    offers: [],
  };
}
